import React, { Component } from "react";
import './HeSi.css';
import { Spinner } from 'reactstrap';
import axios from '../../utils/request';
import { Result, Button } from 'antd';

export class HeSiShowTag extends Component {
    constructor(props) {
        super(props);      
        window.onload=this.loadData;
    };
    async loadData(){
        var pIBADownloadBtn=document.getElementById("PIBADownload");
        var pIBAPreviewBtn=document.getElementById("PIBAPreview");
        pIBADownloadBtn.disabled=true;
        pIBADownloadBtn.innerHTML="正在查询报告...";
        pIBAPreviewBtn.disabled=true;
        pIBAPreviewBtn.innerHTML="正在查询报告...";
        var pICADownloadBtn=document.getElementById("PICADownload");
        var pICAPreviewBtn=document.getElementById("PICAPreview");
        pICADownloadBtn.disabled=true;
        pICADownloadBtn.innerHTML="正在查询报告...";
        pICAPreviewBtn.disabled=true;
        pICAPreviewBtn.innerHTML="正在查询报告...";
        const urlParams = new URLSearchParams(window.location.search);
        var tenantId = urlParams.get("tenantId");
        var commonParamater = urlParams.get("commonParamater");
        var applyId = urlParams.get("applyId");
        var pIBALink=null,pICALink=null,pIBAPreviewLink=null,pICAPreviewLink=null;
        await axios.get(`/api/HeSi_PI/getLink?tenantId=${tenantId}&commonParamater=${commonParamater}&applyId=${applyId}`).then(res => {
            var jsonObj= JSON.parse(res.data.data);
            pIBALink=jsonObj.BALink;
            pICALink=jsonObj.CALink;
            pIBAPreviewLink=jsonObj.BAPreviewLink;
            pICAPreviewLink=jsonObj.CAPreviewLink;
        });
        if(pIBALink!=null&&pIBALink!=""){
            pIBADownloadBtn.setAttribute("urlLink",pIBALink);
            pIBADownloadBtn.disabled=false;
            pIBADownloadBtn.innerHTML="下载";
            pIBAPreviewBtn.disabled=false;
            pIBAPreviewBtn.innerHTML="预览";
            pIBAPreviewBtn.setAttribute("urlLink",pIBAPreviewLink);
        }else{
            pIBADownloadBtn.innerHTML="无下载报告";
            pIBAPreviewBtn.innerHTML="无预览报告";
        }
        if(pICALink!=null&&pICALink!=""){
            pICADownloadBtn.setAttribute("urlLink",pICALink);
            pICADownloadBtn.disabled=false;
            pICADownloadBtn.innerHTML="下载";
            pICAPreviewBtn.disabled=false;
            pICAPreviewBtn.innerHTML="预览";
            pICAPreviewBtn.setAttribute("urlLink",pICAPreviewLink);
        }else{
            pICADownloadBtn.innerHTML="无下载报告";
            pICAPreviewBtn.innerHTML="无预览报告";
        }
    };
    openLink(e){
        var pIBALink=e.currentTarget.getAttribute("urlLink");
        if(pIBALink!=null){
            window.open(pIBALink);
        }
    }
    render() {
        return (
            <p id="tagPage">
                <p>
                    <label>PIBA测评报告：</label>
                    <button id="PIBAPreview" onClick={this.openLink}>无预览报告</button>
                    <button id="PIBADownload" onClick={this.openLink}>无下载报告</button>
                </p>
                <p>
                    <label>PICA测评报告：</label>
                    <button id="PICAPreview" onClick={this.openLink}>无预览报告</button>
                    <button id="PICADownload" onClick={this.openLink}>无下载报告</button>
                </p>
            </p>
        );
    }
}
